<template>
  <div
    class="login-wrap d-flex flex-column align-center justify-center"
    :class="{ standalone: isStandAlonePage }">
    <qx-alert-block
      v-if="disclaimers.length"
      type="warning"
      :text="disclaimers" />
    <div class="login-title">
      {{ title || loginTitle }}
    </div>
    <login-error-message v-if="loginError" />
    <template v-else>
      <share-login-message v-if="isStandAlonePage" />
      <div
        v-if="text"
        class="login-text">
        <slot name="text">
          {{ text }}
        </slot>
      </div>
    </template>
    <slot />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import ShareLoginMessage from '@/components/auth/ShareLoginMessage.vue';
import loginErrorMessage from '@/elements/auth/loginErrorMessage.vue';
import QxAlertBlock from '@/elements/QxAlertBlock.vue';

export default {
  name: 'LoginWrap',
  components: {
    loginErrorMessage,
    ShareLoginMessage,
    QxAlertBlock,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      loginError: (state) => state.auth.loginError,
      isStandAlonePage: (state) => state.isStandAlonePage,
      disclaimers: (state) => state.accountData.disclaimers,
    }),
    ...mapGetters({
      getLoginSpecialData: 'getLoginSpecialData',
    }),
    loginTitle() {
      // should be in computed for correct translation
      return this.getLoginSpecialData.title || this.$gettext('Secure and compliant file sharing');
    },
  },
};
</script>

<style lang="scss" scoped>
.login-wrap {
  width: 500px;
  margin-bottom: 120px;
  &.standalone {
    margin-bottom: 0;
  }
  .login-title {
    font-family: $bold-sans-font;
    font-size: 24px;
    color: $base-grey;
    margin-bottom: 24px;
  }
  .login-text {
    color: $gray-900;
    font-size: 15px;
    text-align: center;
    margin-bottom: 20px;
  }
  :deep form {
    width: 300px;
    margin-bottom: 40px;
    &.verification-code-form {
      width: 340px;
    }
    button {
      height: 40px;
    }
  }
}
</style>
